import { Box, Button, Paper, TextField, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import * as Yup from "yup";

const DateFilterForm = ({ startDate, endDate, onSearch, onClear }) => {
  const validationSchema = Yup.object({
    fromDate: Yup.date().required("Required"),
    toDate: Yup.date().required("Required"),
  });

  return (
    <Paper
      sx={{
        padding: "2rem",
        borderRadius: 2,
        marginTop: "2%",
      }}
    >
      <Formik
        enableReinitialize
        initialValues={{ fromDate: startDate || "", toDate: endDate || "" }}
        validationSchema={validationSchema}
        onSubmit={onSearch}
      >
        {({
          values,
          errors,
          touched,
          setFieldValue,
          handleSubmit,
          resetForm,
        }) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6}>
                <TextField
                  fullWidth
                  id="from-date"
                  name="fromDate"
                  label="From Date"
                  type="date"
                  value={values.fromDate}
                  onChange={(event) => {
                    setFieldValue("fromDate", event.target.value);
                  }}
                  InputLabelProps={{ shrink: true }}
                  error={touched.fromDate && Boolean(errors.fromDate)}
                  helperText={touched.fromDate && errors.fromDate}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <TextField
                  fullWidth
                  id="to-date"
                  name="toDate"
                  label="To Date"
                  type="date"
                  value={values.toDate}
                  onChange={(event) => {
                    setFieldValue("toDate", event.target.value);
                  }}
                  InputLabelProps={{ shrink: true }}
                  error={touched.toDate && Boolean(errors.toDate)}
                  helperText={touched.toDate && errors.toDate}
                />
              </Grid>

              <Grid item xs={12} sx={{ marginTop: "3%" }}>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                  gap={2}
                >
                  <Button
                    onClick={handleSubmit}
                    sx={{
                      backgroundColor: "#027BFE",
                      color: "white",
                      height: "56px",
                      textTransform: "none",
                      borderRadius: "10px",
                      width: "120px",
                    }}
                  >
                    Search
                  </Button>
                  <Button
                    onClick={() => {
                      resetForm();
                      onClear(); // Clears parent state as well
                    }}
                    sx={{
                      backgroundColor: "gray",
                      color: "white",
                      height: "56px",
                      textTransform: "none",
                      borderRadius: "10px",
                      width: "120px",
                    }}
                  >
                    Clear
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Paper>
  );
};

export default DateFilterForm;
